import {
  IonInput,
  IonGrid,
  IonRow,
  IonCol,
  IonItem,
  IonButton,
  IonIcon,
  useIonToast,
  IonPage,
  IonSpinner,
  IonText,
} from "@ionic/react";
import { Redirect } from "react-router-dom";
import { lockClosed, person } from "ionicons/icons";
import { useState } from "react";
import { useFirebase } from "../components/firebase-provider";
import PageLayout from "../components/layout";

import "../style/login-page.css";

interface LoginForm {
  email: string;
  password: string;
}
const LoginPage: React.FC<any> = ({ location }) => {
  const [toast] = useIonToast();
  const [form, setForm] = useState<LoginForm>({
    email: "",
    password: "",
  });

  const [submit, setSubmit] = useState<{ status: boolean; text: string }>({
    status: false,
    text: "Masuk",
  });

  const { user, loading, auth } = useFirebase();

  const handleChange = (el: any) =>
    setForm({ ...form, [el.target.name]: el.detail.value });

  const handleLogin = async (e: any) => {
    e.preventDefault();
    try {
      setSubmit({
        status: true,
        text: "Sedang Masuk. . .",
      });
      await auth.signInWithEmailAndPassword(form.email, form.password);
    } catch (err) {
      let er = "";
      switch (err.code) {
        case "auth/user-not-found":
          er = "Akun tidak ditemukan";
          break;
        case "auth/invalid-email":
          er = "Email salah!";
          break;
        case "auth/wrong-password":
          er = "Kata sandi salah!";
          break;
        case "auth/user-disabled":
          er = "Akun kamu diblokir!";
          break;
        default:
          er = "Terjadi kesalahan yang tidak diketahui";
          break;
      }

      toast({
        message: er,
        duration: 3000,
        color: "danger",
        position: "top",
      });
    }
    setSubmit({
      status: false,
      text: "Masuk",
    });
  };

  if (user) {
    const redirecTo =
      location.state && location.state.from && location.state.from.pathname
        ? location.state.from.pathname
        : "/app";
    return <Redirect to={redirecTo} />;
  }

  if (loading) {
    return (
      <IonPage>
        <section
          style={{
            width: "100vw",
            height: "100vh",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column",
          }}
        >
          <IonSpinner color="medium" />
          <IonText color="medium">
            <p><small>Tunggu...</small></p>
          </IonText>
        </section>
      </IonPage>
    );
  }

  return (
    <>
      <PageLayout title="Masuk">
        <IonGrid className="login-grid">
          <IonRow>
            <IonCol className="ion-align-self-center ">
              <form id="LoginForm" onSubmit={handleLogin}>
                <IonItem>
                  <IonIcon icon={person} slot="start" />
                  <IonInput
                    name="email"
                    type="email"
                    placeholder="E-Mail"
                    value={form.email}
                    onIonChange={handleChange}
                    required
                  ></IonInput>
                </IonItem>
                <IonItem>
                  <IonIcon icon={lockClosed} slot="start" />
                  <IonInput
                    name="password"
                    type="password"
                    placeholder="Kata Sandi"
                    value={form.password}
                    onIonChange={handleChange}
                    required
                  ></IonInput>
                </IonItem>
                <br />
                <IonButton
                  className="ion-margin-top"
                  disabled={
                    form.email === "" || form.password === "" || submit.status
                  }
                  mode="ios"
                  type="submit"
                  expand="block"
                >
                  {submit.text}
                </IonButton>
              </form>
            </IonCol>
          </IonRow>
          <IonRow>
            <IonCol className="ion-text-center">
              <IonButton
                mode="ios"
                fill="clear"
                expand="block"
                routerLink="/dashboard"
              >
                Lupa kata sandi?
              </IonButton>
            </IonCol>
          </IonRow>
        </IonGrid>
      </PageLayout>
    </>
  );
};

export default LoginPage;
